import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: '页面大小',
	PageOrientation: '页面方向',
	Format: '格式',
	DPI: '像素',
	Generate: '导出',
	LanguageName: '简体字',
	LanguageCode: 'zhHans'
};

export default translation;
